// extracted by mini-css-extract-plugin
export default {"Subpage":"advancedStatistics_Subpage__5J4JS","ChartsContainer":"advancedStatistics_ChartsContainer__f4KF5"};